// @flow
import React, { Component } from 'react';
import {
  SidebarDeviceTopDiv,
  CloseIconDiv,
  SidebarTopDiv,
  SidebarLogoImg,
  SidebarSpacerDiv
} from './SidebarStyles';
import { DefaultIcon } from '../../../components/Icon';
import SidebarItem from './SidebarItem';
import netcents from '../../../assets/images/netcents-white.png';
import netcentsLogomark from '../../../assets/images/netcents-logomark-white.png';
type Props = {
  sidebarOpened: boolean,
  toggleSidebarDevice: () => void,
  flippers: {
    partner_referrals: boolean
  }
};

export default class SidebarTop extends Component<Props> {
  render() {
    return (
      <>
        <SidebarDeviceTopDiv>
          <CloseIconDiv onClick={this.props.toggleSidebarDevice}>
            <DefaultIcon name="x" />
          </CloseIconDiv>
          <SidebarTopDiv>
            <SidebarLogoImg
              src={this.props.sidebarOpened ? netcents : netcentsLogomark}
            />
          </SidebarTopDiv>
          <SidebarSpacerDiv desktopOnly />
          <SidebarItem
            to="/"
            label="Dashboard"
            icon="home"
            exact
            baseRoute="dashboard"
          />
          <SidebarItem
            to="/commission-payouts/due"
            label="Commission payouts"
            icon="handMoney"
            baseRoute="commission-payouts"
          />
          <SidebarItem
            to="/merchants"
            label="Direct Merchants"
            icon="merchant"
            baseRoute="merchants"
          />
          {this.props.flippers.partner_referrals && (
            <SidebarItem
              to="/partners/referred"
              label="Partners"
              icon="partners"
              baseRoute="partners"
              excludeRoute="marketing"
            />
          )}
        </SidebarDeviceTopDiv>
      </>
    );
  }
}
